module.exports = __webpack_public_path__ + "img/image1.1.ae062e96.png";